const values = [
  "Y19201",
  "Y19211",
  "Y19221",
  "Y19231",
  "Y19241",
  "Y19251",
  "Y19261",
  "Y19271",
  "Y19281",
  "Y19291",
  "Y19301",
  "Y19311",
  "Y19321",
  "Y19331",
  "Y19341",
  "Y19351",
  "Y19361",
  "Y19371",
  "Y19381",
  "Y19391",
  "Y19401",
  "Y19411",
  "Y19421",
  "Y19431",
  "Y19441",
  "Y19451",
  "Y19461",
  "Y19471",
  "Y19481",
  "Y19491",
  "Y19501",
  "Y19511",
  "Y19521",
  "Y19531",
  "Y19541",
  "Y19551",
  "Y19561",
  "Y19571",
  "Y19581",
  "Y19591",
  "Y19601",
  "Y19611",
  "Y19621",
  "Y19631",
  "Y19641",
  "Y19651",
  "Y19661",
  "Y19671",
  "Y19681",
  "Y19691",
  "Y19701",
  "Y19711",
  "Y19721",
  "Y19731",
  "Y19741",
  "Y19751",
  "Y19761",
  "Y19771",
  "Y19781",
  "Y19791",
  "Y19801",
  "Y19811",
  "Y19821",
  "Y19831",
  "Y19841",
  "Y19851",
  "Y19861",
  "Y19871",
  "Y19881",
  "Y19891",
  "Y19901",
  "Y19911",
  "Y19921",
  "Y19931",
  "Y19941",
  "Y19951",
  "Y19961",
  "Y19971",
  "Y19981",
  "Y19991",
  "Y20001",
  "Y20011",
  "Y20021",
  "Y20031",
  "Y20041",
  "Y20051",
  "Y20061",
  "Y20071",
  "Y20081",
  "Y20091",
  "Y20101",
  "Y20111",
  "Y20121",
  "Y20131",
  "Y20141",
  "Y20151",
  "Y20161",
  "Y20171",
  "Y20181"
];

const arr = values
  .map((value, index) => {
    const label = 1920 + index + "/1";

    return {
      value,
      label
    };
  })
  .reverse();

export default arr;



// WEBPACK FOOTER //
// ./src/utils/UfvYears.tsx